import { TestIdClassNameProps } from "@app/types/Common";
import { Tag } from "@app/types/Cue";
import { MyBTKeywordsDataList } from "@app/types/Page";
import SplideArrows from "@components/Slider/components/SplideArrows";
import {
  Options,
  Splide,
  SplideSlide,
  SplideTrack,
} from "@greglaisph/react-splide";
import { cn } from "@util/helpers";

import MyBTCarouselSlide from "./MyBTCarouselSlide";

type MyBTCarouselProps = TestIdClassNameProps & {
  /** The header of the carousel, normally a BlockTitle */
  header?: React.ReactNode;
  results: MyBTKeywordsDataList;
  keywords: Tag[];
  title: string;
  showTooltip: boolean;
  disablePaywall?: boolean;
  /** The class name for the wrapper of the arrows */
  arrowWrapperClassName?: string;
  /** The class name for the wrapper of the slide */
  slideWrapperClassName?: string;
  /** The class name for the divider */
  dividerClassName?: string;
  /** The class name for the icon */
  iconClassName?: string;
  /** Ref code to be added on the article links. */
  refCode?: string;
};

export default function MyBTHomeCarousel({
  header,
  testId,
  rootClassName,
  results,
  keywords,
  disablePaywall = false,
  arrowWrapperClassName,
  slideWrapperClassName,
  dividerClassName,
  iconClassName,
  refCode,
}: MyBTCarouselProps): React.ReactElement {
  const options: Options = {
    pagination: false,
    type: "slide",
    autoplay: false,
    interval: 10000,
    perMove: 1,
    gap: "1.5rem",
    focus: 0,
    omitEnd: true,
    mediaQuery: "min",
    arrows: false,
    fixedWidth: "65%",
    breakpoints: {
      768: { fixedWidth: "38%", arrows: true },
      992: { perPage: 4, fixedWidth: undefined },
    },
  };

  return (
    <div className={rootClassName} data-testid={testId}>
      {header}

      <Splide
        options={options}
        tag="div"
        hasTrack={false}
        className={cn({ "mt-8": !header })}
      >
        <SplideArrows
          className={cn(
            "absolute -top-8 right-0 flex flex-row items-center justify-center gap-2",
            arrowWrapperClassName
          )}
        />

        <SplideTrack>
          {keywords.map((keyword) => {
            const keywordData = results[keyword.urlPath];

            return keywordData?.body ? (
              <SplideSlide key={keyword.urlPath} className="pt-6">
                <MyBTCarouselSlide
                  articles={keywordData.body}
                  tag={keyword}
                  disablePaywall={disablePaywall}
                  className={slideWrapperClassName}
                  dividerClassName={dividerClassName}
                  iconClassName={iconClassName}
                  refCode={refCode}
                />
              </SplideSlide>
            ) : null;
          })}
        </SplideTrack>
      </Splide>
    </div>
  );
}
